//
// Module for the Employment Codes Edit view
//
rs.module("content/employer/account/employmentcodes/edit",

    ["common/select-helper", "common/visibility"],

    function (selectHelper, visibility) {

        // Initialize the module
        function initialize(jsSelectors, backendUrl) {

            // Unpack js selectors
            var form = $.js(jsSelectors.form);
            var employmentCodeGroupSelect = form.js(jsSelectors.employmentCodeGroupSelect);

            var codeValueSelectContainer = form.js(jsSelectors.codeValueSelectContainer);
            var codeValueSelect = form.js(jsSelectors.codeValueSelect);
            var codeValueCreateLink = form.js(jsSelectors.codeValueCreateLink);
            var codeValueCreateContainer = form.js(jsSelectors.codeValueCreateContainer);
            var isCreatingNewCodeValue = form.js(jsSelectors.isCreatingNewCodeValue, { multiple: true });
            var codeValueCreateName = form.js(jsSelectors.codeValueCreateName);
            var codeValueCreateCancelLink = form.js(jsSelectors.codeValueCreateCancelLink);

            var cancelButton = form.js(jsSelectors.cancelButton);

            // Get Select Helpers for populating drop downs
            var availableValuesSelectHelper = selectHelper.getHelper(codeValueSelect);

            // Set listeners for drop down change actions
            employmentCodeGroupSelect.change(populateAvailableCodeValues);

            // Populate the available code values based on the selected code group
            function populateAvailableCodeValues() {

                availableValuesSelectHelper.clearOptions();

                $.getJSON(backendUrl, { selectedEmploymentCodeGroup: employmentCodeGroupSelect.val() }).done(function (data) {

                    availableValuesSelectHelper.replaceOptions(data.list, { withBlank: true });

                    // Update the cancel button url which includes the new employment group code
                    cancelButton.attr('href', data.indexUrl);
                });
            }

            // codeValue create link click handler
            codeValueCreateLink.click(onCodeValueCreateLinkClicked);

            // codeValue create link click handler
            codeValueCreateCancelLink.click(onCodeValueCreateCancelLinkClicked);

            // codeValue create link click handler
            function onCodeValueCreateLinkClicked() {
                visibility.setVisible(codeValueSelectContainer, false);
                visibility.setVisible(codeValueCreateContainer, true);

                // reset employment codeValue key to null
                availableValuesSelectHelper.setValue(null);

                // set creating new codeValue flag used for validation
                //isCreatingNewCodeValue.each(function () { $(this).val(true); });
                isCreatingNewCodeValue.val(true);
            }

            // codeValue create cancel link click handler
            function onCodeValueCreateCancelLinkClicked() {
                visibility.setVisible(codeValueSelectContainer, true);
                visibility.setVisible(codeValueCreateContainer, false);

                // set creating new codeValue flag used for validation
                //isCreatingNewCodeValue.each(function () { $(this).val(false); });
                isCreatingNewCodeValue.val(false);
                // clear out codeValue create fields and reset codeValue select text
                codeValueCreateName.val("");
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);